import Hosts from '../../../Hosts';

const object_type = 'Entidade02'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/entities`
const api_list_route = companycode => `${Hosts.SIMCore_API}/entities/list/${companycode}/${object_type}`

const base_endpoint = '/entidade02'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    detalhesEntidade: `${base_endpoint}_detalhesEntidade/:id`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        username: '',
        password: '',
        name: '',
        // birthday: "",
        rgpd: false,
        ativo: true,
        vat: '',
        identificacao: {
            tipo_identificacao: '',
            numero_identificacao: '',
            validade_identificacao: ''
        },
        observation: '',
        entity_type: '',
        dataAberturaFicha: "",
        // departamento: [],
        nameDominio: "",
        ssl: "",
        gd: "",
        site: "",
        obs: "",
    },
    addresses: [{
        village: '',
        city: '',
        type: [],
        region: '',
        country: '',
        apartado: '',
        localidade: '',
        contats: [],
        principal: '',
        observation: '',
        postal_code: '',
        street_name: '',
        address_detail: '',
    }],
    contacts: [{
        email: '',
        phone: '',
        principal: 'true',
        extensions: [],
        observation: '',
        mobile_phone: '',
        building_number: '',
        departamentos: [{
            person_responsables: [{
                // name: '',
                // email: '',
                // extensions: '',
                // observation: '',
                // mobile_phone: ''
            }],
        }],
    }],
    profile: { name: 'Entidade02' },    
    //guardar aqui o tipo de utilizador
    notifications: []
}

export {
    object_type,
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
